import { getParentCategories } from "../Components/Menu/Helpers";
import { isNotExcludedProuduct } from "../store/reducers/cart";
import { store } from "../store";
import {
  getTotalExcludeProducts,
  getCategoryTotal,
  preciseNumber,
} from "../store/reducers/cart";
import {getCurrencyIso} from "./currencyConverter";

let getNewPrice = (product, coupon, discounts, smartPromos) => {
  let discountAmount = getProductDiscountAmount(
    product,
    coupon,
    discounts,
    smartPromos
  );

  return getDiscountedPrice(product.price, discountAmount);
};

let getProductDiscountAmount = (product, coupon, discounts, smartPromos) => {
  let discountAmount = {
    total: 0,
    excludedModifiers: [],
    discountedModifiers: [],
  };
  // total percent discount
  if (coupon && coupon.discount_type === "percent") {
    discountAmount.total += coupon.discount_amount;
  } else if (
    (!coupon || (coupon && coupon.discount_type !== "percent")) &&
    discounts &&
    discounts.percent[0]
  ) {
    let store_discount = smartPromos.find(
      (promo) => promo.id === discounts.percent[0].promo
    );

    if (
      store_discount &&
      isNotExcludedProuduct(
        product,
        store_discount.excluded_products,
        store_discount.excluded_categories
      )
    ) {
      if (store_discount.excluded_modifiers.length) {
        discountAmount.excludedModifiers.push({
          modifiers: store_discount.excluded_modifiers,
          discountAmount: discounts.percent[0].discount_amount,
        });
      } else {
        discountAmount.total += discounts.percent[0].discount_amount;
      }
    }
  }
  //Category Discount
  if (discounts && discounts.category.length) {
    discounts.category.forEach((d) => {
      let parentCategories = [];
      if (product.category_is_child) {
        parentCategories = getParentCategories(
          product.category_id,
          store.getState().store.store.categories
        ).parentCategories;
      }
      if (
        d.categories.includes(product.category_id) ||
        d.categories.some((c) => parentCategories.includes(c))
      ) {
        let store_discount = smartPromos.find((promo) => promo.id === d.promo);
        if (
          store_discount &&
          isNotExcludedProuduct(
            product,
            store_discount.excluded_products,
            store_discount.excluded_categories
          )
        ) {
          if (store_discount.excluded_modifiers.length) {
            discountAmount.excludedModifiers.push({
              modifiers: store_discount.excluded_modifiers,
              discountAmount: d.discount_amount,
            });
          } else {
            discountAmount.total += d.discount_amount;
          }
        }
      }
    });
  }

  // product discounts
  if (discounts && discounts.products_percent.length) {
    discounts.products_percent.forEach((d) => {
      if (
        d.products.includes(product.id) ||
        d.products.includes(product.parent)
      ) {
        let store_discount = smartPromos.find((promo) => promo.id === d.promo);
        if (
          store_discount &&
          isNotExcludedProuduct(
            product,
            store_discount.excluded_products,
            store_discount.excluded_categories
          )
        ) {
          if (store_discount.excluded_modifiers.length) {
            discountAmount.excludedModifiers.push({
              modifiers: store_discount.excluded_modifiers,
              discountAmount: d.discount_amount,
            });
          } else {
            discountAmount.total += d.discount_amount;
          }
        }
      }
    });
  }

  // modifier discount
  if (discounts && discounts.modifier.length) {
    discounts.modifier.forEach((d) => {
      let store_discount = smartPromos.find((promo) => promo.id === d.promo);
      if (
        store_discount &&
        isNotExcludedProuduct(
          product,
          store_discount.excluded_products,
          store_discount.excluded_categories
        )
      ) {
        discountAmount.discountedModifiers.push({
          modifiers: d.modifiers,
          discountAmount: d.discount_amount,
        });
      }
    });
  }

  return discountAmount;
};

let getOrderDiscount = (price, cart, coupon, discounts, smartPromos) => {
  let discount_amount = 0;
  let hasMaxDiscountAmount = false;
  let discountAmountPerPromo = smartPromos.reduce((dict, promo) => {
    if (promo.max_discount_amount > 0) {
      hasMaxDiscountAmount = true;
    }
    dict[promo.id] = {
      totalDiscount: 0,
      maxDiscountAmount: promo.max_discount_amount || Infinity,
    };
    return dict;
  }, {});
  if (coupon && coupon.discount_type === "fixed") {
    discount_amount += coupon.discount_amount;
    discountAmountPerPromo[`c-${coupon?.id}`] = {
      totalDiscount: discount_amount,
      maxDiscountAmount: Infinity,
    };
  } else if (coupon && coupon.discount_type === "percent") {
    discount_amount += (price * coupon.discount_amount) / 100;

    discountAmountPerPromo[`c-${coupon?.id}`] = {
      totalDiscount: discount_amount,
      maxDiscountAmount: Infinity,
    };
  }
  if (discounts) {
    if (
      discounts.fixed[0] &&
      (!coupon || (coupon && coupon.discount_type !== "fixed"))
    ) {
      discount_amount += discounts.fixed[0].discount_amount;
      if (discountAmountPerPromo[discounts.fixed[0].promo]) {
        discountAmountPerPromo[discounts.fixed[0].promo].totalDiscount +=
          discounts.fixed[0].discount_amount;
      }
    }
    if (
      discounts.percent[0] &&
      (!coupon || (coupon && coupon.discount_type !== "percent"))
    ) {
      let store_discount = smartPromos.find(
        (promo) => promo.id === discounts.percent[0].promo
      );

      let percent_discount_amount = 0;
      if (
        store_discount &&
        (store_discount.excluded_products.length ||
          store_discount.excluded_categories.length ||
          store_discount.excluded_modifiers.length)
      ) {
        percent_discount_amount = getDiscountExcludeProducts(
          cart,
          store_discount.excluded_products,
          store_discount.excluded_categories,
          store_discount.excluded_modifiers,
          discounts.percent[0].discount_amount
        );
      } else {
        percent_discount_amount =
          (price * discounts.percent[0].discount_amount) / 100;
      }

      discount_amount += percent_discount_amount;

      if (discountAmountPerPromo[discounts.percent[0].promo]) {
        discountAmountPerPromo[discounts.percent[0].promo].totalDiscount +=
          percent_discount_amount;
      }
    }
    if (discounts.category.length) {
      discount_amount += getCategoryDiscountsAmount(
        cart,
        discounts.category,
        smartPromos,
        discountAmountPerPromo
      );
    }
    if (discounts.products_percent.length) {
      discount_amount += getProductsDiscountsAmount(
        cart,
        discounts.products_percent,
        smartPromos,
        discountAmountPerPromo
      );
    }
    if (discounts.modifier.length) {
      discount_amount += getModifiersDiscountsAmount(
        cart,
        discounts.modifier,
        smartPromos,
        discountAmountPerPromo
      );
    }
  }
  if (hasMaxDiscountAmount) {
    discount_amount = Object.values(discountAmountPerPromo).reduce(
      (totalDiscount, promo) =>
        totalDiscount + Math.min(promo.totalDiscount, promo.maxDiscountAmount),
      0
    );
  }
  return discount_amount;
};

let getDiscountExcludeProducts = (
  cart,
  excluded_products,
  excluded_categories,
  excludedModifiers,
  value
) => {
  let discount_amount = 0;
  cart.forEach((product) => {
    if (
      isNotExcludedProuduct(product, excluded_products, excluded_categories)
    ) {
      if (!excludedModifiers.length) {
        discount_amount +=
          ((product.total_price * product.quantity +
            product.quantityExcludedOptionsTotal) *
            value) /
          100;
      } else {
        let productTotalPrice =
          product.total_price * product.quantity +
          product.quantityExcludedOptionsTotal;

        // check for modifiers

        Object.entries(product.options).forEach(([optionID, option]) => {
          Object.entries(option.selectedOptions).forEach(
            ([choiceID, choice]) => {
              if (excludedModifiers.includes(choice.modifier)) {
                productTotalPrice -=
                  choice.price *
                  choice.quantity *
                  ((option.quantityExclusive && 1) || product.quantity);
              }
            }
          );
        });

        discount_amount += (productTotalPrice * value) / 100;
      }
    }
  });

  return discount_amount;
};
let getCategoryDiscountsAmount = (
  cart,
  categoryDiscounts,
  smartPromos,
  discountAmountPerPromo = {}
) => {
  let discountAmount = 0;

  cart.forEach((product) => {
    let parentCategories = [];
    if (product.category_is_child) {
      parentCategories = getParentCategories(
        product.category_id,
        store.getState().store.store.categories
      ).parentCategories;
    }

    categoryDiscounts.forEach((categoryDiscount) => {
      if (
        categoryDiscount.categories.includes(product.category_id) ||
        (parentCategories.length &&
          categoryDiscount.categories.some((c) => parentCategories.includes(c)))
      ) {
        let store_discount = smartPromos.find(
          (promo) => promo.id === categoryDiscount.promo
        );
        if (
          store_discount &&
          isNotExcludedProuduct(
            product,
            store_discount.excluded_products,
            store_discount.excluded_categories
          )
        ) {
          if (!store_discount.excluded_modifiers.length) {
            discountAmount +=
              ((product.total_price * product.quantity +
                product.quantityExcludedOptionsTotal) *
                categoryDiscount.discount_amount) /
              100;
            discountAmountPerPromo[store_discount.id].totalDiscount +=
              ((product.total_price * product.quantity +
                product.quantityExcludedOptionsTotal) *
                categoryDiscount.value) /
              100;
          } else {
            let productTotalPrice =
              product.total_price * product.quantity +
              product.quantityExcludedOptionsTotal;

            // check for modifiers

            Object.entries(product.options).forEach(([optionID, option]) => {
              Object.entries(option.selectedOptions).forEach(
                ([choiceID, choice]) => {
                  if (
                    store_discount.excluded_modifiers.includes(choice.modifier)
                  ) {
                    productTotalPrice -=
                      choice.price *
                      choice.quantity *
                      ((option.quantityExclusive && 1) || product.quantity);
                  }
                }
              );
            });

            discountAmount +=
              (productTotalPrice * categoryDiscount.discount_amount) / 100;

            discountAmountPerPromo[store_discount.id].totalDiscount +=
              (productTotalPrice * categoryDiscount.discount_amount) / 100;
          }
        }
      }
    });
  });

  return discountAmount;
};
let getProductsDiscountsAmount = (
  cart,
  productDiscounts,
  smartPromos,
  discountAmountPerPromo = {}
) => {
  let discountAmount = 0;

  cart.forEach((product) => {
    productDiscounts.forEach((productDiscount) => {
      if (
        productDiscount.products.includes(product.id) ||
        productDiscount.products.includes(product.parent)
      ) {
        let store_discount = smartPromos.find(
          (promo) => promo.id === productDiscount.promo
        );
        if (
          store_discount &&
          isNotExcludedProuduct(
            product,
            store_discount.excluded_products,
            store_discount.excluded_categories
          )
        ) {
          if (!store_discount.excluded_modifiers.length) {
            discountAmount +=
              ((product.total_price * product.quantity +
                product.quantityExcludedOptionsTotal) *
                productDiscount.discount_amount) /
              100;
            discountAmountPerPromo[store_discount.id].totalDiscount +=
              ((product.total_price * product.quantity +
                product.quantityExcludedOptionsTotal) *
                productDiscount.value) /
              100;
          } else {
            let productTotalPrice =
              product.total_price * product.quantity +
              product.quantityExcludedOptionsTotal;

            // check for modifiers

            Object.entries(product.options).forEach(([optionID, option]) => {
              Object.entries(option.selectedOptions).forEach(
                ([choiceID, choice]) => {
                  if (
                    store_discount.excluded_modifiers.includes(choice.modifier)
                  ) {
                    productTotalPrice -=
                      choice.price *
                      choice.quantity *
                      ((option.quantityExclusive && 1) || product.quantity);
                  }
                }
              );
            });

            discountAmount +=
              (productTotalPrice * productDiscount.discount_amount) / 100;

            discountAmountPerPromo[store_discount.id].totalDiscount +=
              (productTotalPrice * productDiscount.discount_amount) / 100;
          }
        }
      }
    });
  });

  return discountAmount;
};

let getModifiersDiscountsAmount = (
  cart,
  modifiersDiscount,
  smartPromos,
  discountAmountPerPromo = {}
) => {
  let discountAmount = 0;

  cart.forEach((product) => {
    modifiersDiscount.forEach((modifierDiscount) => {
      let store_discount = smartPromos.find(
        (promo) => promo.id === modifierDiscount.promo
      );

      if (
        store_discount &&
        isNotExcludedProuduct(
          product,
          store_discount.excluded_products,
          store_discount.excluded_categories
        )
      ) {
        Object.entries(product.options).forEach(([optionID, option]) => {
          Object.entries(option.selectedOptions).forEach(
            ([choiceID, choice]) => {
              if (
                modifierDiscount.modifiers.includes(choice.modifier) &&
                !store_discount.excluded_modifiers.includes(choice.modifier)
              ) {
                discountAmount +=
                  (choice.price *
                    choice.quantity *
                    ((option.quantityExclusive && 1) || product.quantity) *
                    modifierDiscount.discount_amount) /
                  100;

                discountAmountPerPromo[store_discount.id].totalDiscount +=
                  (choice.price *
                    choice.quantity *
                    ((option.quantityExclusive && 1) || product.quantity) *
                    modifierDiscount.value) /
                  100;
              }
            }
          );
        });
      }
    });
  });

  return discountAmount;
};
let getDiscountedPrice = (
  price,
  discountAmount,
  modifierID,
  options,
  productQuantiy = 1
) => {
  let totalDiscountAmount = (price * discountAmount.total) / 100;

  // check for modifiers
  if (discountAmount.excludedModifiers?.length) {
    discountAmount.excludedModifiers.forEach((discount) => {
      let priceTobeDiscounted = price;
      if (options) {
        Object.entries(options).forEach(([optionID, option]) => {
          Object.entries(option.selectedOptions).forEach(
            ([choiceID, choice]) => {
              if (discount.modifiers.includes(choice.modifier)) {
                priceTobeDiscounted -=
                  choice.price *
                  choice.quantity *
                  ((option.quantityExclusive && 1) || productQuantiy);
              }
            }
          );
        });
      }
      if (!discount.modifiers.includes(modifierID)) {
        totalDiscountAmount +=
          (priceTobeDiscounted * discount.discountAmount) / 100;
      }
    });
  }

  if (options && discountAmount.discountedModifiers?.length) {
    discountAmount.discountedModifiers.forEach((discount) => {
      Object.entries(options).forEach(([optionID, option]) => {
        Object.entries(option.selectedOptions).forEach(([choiceID, choice]) => {
          if (discount.modifiers.includes(choice.modifier)) {
            totalDiscountAmount +=
              (choice.price *
                choice.quantity *
                ((option.quantityExclusive && 1) || productQuantiy) *
                discount.discountAmount) /
              100;
          }
        });
      });
    });
  }

  if (modifierID && discountAmount.discountedModifiers.length) {
    discountAmount.discountedModifiers.forEach((discount) => {
      if (discount.modifiers.includes(modifierID)) {
        totalDiscountAmount += (price * discount.discountAmount) / 100;
      }
    });
  }

  price -= totalDiscountAmount;
  if (price <= 0) price = 0;
  return price;
};

const getDiscountedPercentage = (discountedPrice, originalPrice) => {
  return Math.round((100 * (originalPrice - discountedPrice)) / originalPrice);
};

const isApplicableCategeoryPromo = (categories, product) => {
  if (categories.includes(product.category_id)) return true;
  if (product.category_is_child) {
    const parentCategories = getParentCategories(
      product.category_id,
      store.getState().store.store.categories
    ).parentCategories;
    return categories.some((c) => parentCategories.includes(c));
  }
  return false;
};

function getSmartPromoProgress(promo, props) {
  let {
    appliedCoupon,
    cart,
    totalPrice,
    totalItems,
    customerAddress,
    branch,
    authUser,
    delivery,
    categories,
  } = props;

  let conditionsLeft = {
    value: 0,
    number: 0,
    products: [],
    coupon: false,
    points: false,
    category_value: [],
    category_number: [],
    userError: false,
  };
  let value = 0;

  let numberOfConditions = promo.conditions.length;

  let checker_value = 0;

  if (
    promo.excluded_products.length ||
    promo.excluded_categories.length ||
    promo.excluded_modifiers.length
  ) {
    [totalPrice, totalItems] = getTotalExcludeProducts(
      cart,
      promo.excluded_products,
      promo.excluded_categories,
      promo.excluded_modifiers
    );
  }
  if (
    !authUser &&
    (promo.quantity_per_user >= 1 ||
      promo.discounts.some((d) =>
        ["cashback_fixed", "cashback_percent"].includes(d.type)
      ))
  ) {
    numberOfConditions += 1;
    conditionsLeft["userError"] = true;
  }
  promo.conditions.forEach((condition) => {
    if (condition.type === "products") {
      let number_of_item_in_cart = 0;
      condition.products.forEach((product) => {
        cart.forEach((cart_item) => {
          if (
            cart_item.id === product.product ||
            cart_item.parent == product.product
          ) {
            number_of_item_in_cart += cart_item.quantity;
          }
        });
      });
      if (number_of_item_in_cart >= condition.value)
        value += 100 / numberOfConditions;
      else {
        conditionsLeft["products"].push({
          name: condition.products.map((p) => p.name).join(","),
          ar_name: condition.products.map((p) => p.ar_name || p.nane).join(","),
          quantity: preciseNumber(condition.value - number_of_item_in_cart),
        });
      }
    } else if (condition.type === "value" || condition.type === "number") {
      if (condition.type === "value") checker_value = totalPrice;
      else if (condition.type === "number") checker_value = totalItems;
      if (checker_value < condition.value) {
        value += ((checker_value / condition.value) * 100) / numberOfConditions;
        conditionsLeft[condition.type] = preciseNumber(
          condition.value - checker_value
        );
      } else {
        value += 100 / numberOfConditions;
        conditionsLeft[condition.type] = 0;
      }
    } else if (condition.type === "coupon") {
      if (appliedCoupon && appliedCoupon.id === promo.id) {
        value += 100 / numberOfConditions;
      } else {
        conditionsLeft[condition.type] = true;
      }
    } else if (condition.type === "category_value") {
      let [categoryTotalPrice, _] = getCategoryTotal(
        cart,
        condition.categories?.ids,
        promo.excluded_products,
        promo.excluded_categories,
        promo.excluded_modifiers,
        categories
      );
      if (categoryTotalPrice < condition.value) {
        value +=
          ((categoryTotalPrice / condition.value) * 100) / numberOfConditions;
        conditionsLeft.category_value.push({
          names: condition.categories.names,
          valueLeft: preciseNumber(condition.value - categoryTotalPrice),
        });
      } else {
        value += 100 / numberOfConditions;
      }
    } else if (condition.type === "category_number") {
      let [_, categoryTotalQuantity] = getCategoryTotal(
        cart,
        condition.categories?.ids,
        promo.excluded_products,
        promo.excluded_categories,
        promo.excluded_modifiers,
        categories
      );
      if (categoryTotalQuantity < condition.value) {
        value +=
          ((categoryTotalQuantity / condition.value) * 100) /
          numberOfConditions;
        conditionsLeft.category_number.push({
          names: condition.categories.names,
          valueLeft: preciseNumber(condition.value - categoryTotalQuantity),
        });
      } else {
        value += 100 / numberOfConditions;
      }
    } else if (condition.type == "service_type") {
      const serviceTypes = { 0: "delivery", 1: "pickup" };

      if (
        serviceTypes[customerAddress?.selectedDeliveryType] !== condition.value
      ) {
        conditionsLeft.service_type = condition.value;
      } else {
        value += 100 / numberOfConditions;
      }
    } else if (condition.type == "delivery_arrival_time") {
      const orderTypes = { 0: "asap", 1: "scheduled" };

      if (orderTypes[delivery?.type] !== condition.value) {
        conditionsLeft.delivery_arrival_time = condition.value;
      } else {
        value += 100 / numberOfConditions;
      }
    } else if (condition.type == "delivery_area") {
      let area_id;
      if (customerAddress?.selectedDeliveryType === 0) {
        if (branch?.branch) {
          area_id = branch.bdc;
        } else {
          area_id = customerAddress.area;
        }
      }

      if (area_id && condition.value?.ids.includes(area_id)) {
        value += 100 / numberOfConditions;
      } else {
        conditionsLeft.delivery_area = condition.value?.area_names;
      }
    } else if (condition.type == "branch") {
      let branch_id;
      if (branch?.branch) {
        branch_id = branch.branch;
      } else if (customerAddress?.selectedDeliveryType === 1) {
        branch_id = customerAddress.pickupArea;
      }

      if (branch_id && condition.value?.ids.includes(branch_id)) {
        value += 100 / numberOfConditions;
      } else {
        conditionsLeft.branch = condition.value.branch_names;
      }
    } else if (condition.type == "country") {
      let country_id = customerAddress?.country;

      if (country_id && condition.value?.ids.includes(country_id)) {
        value += 100 / numberOfConditions;
      } else {
        conditionsLeft.country = condition.value.country_names;
      }
    } else if (condition.type == "card_scheme") {
      conditionsLeft.card_scheme = condition.value;
    } else if (condition.type == "card_bank") {
      conditionsLeft.card_bank = condition.value;
    } else if (condition.type === "points") {
      if (!authUser) {
        conditionsLeft["userError"] = true;
      }
      if (appliedCoupon && appliedCoupon.id === promo.id) {
        value += 100 / numberOfConditions;
      } else {
        conditionsLeft[condition.type] = true;
      }
    } else if (
      condition.type.startsWith("orders") ||
      condition.type === "first_time"
    ) {
      if (!authUser) {
        conditionsLeft["userError"] = true;
      } else {
        if (condition.type === "orders_more") {
          if (authUser.orders_count > condition.value) {
            value += 100 / numberOfConditions;
          } else {
            conditionsLeft.orders_more = preciseNumber(
              condition.value - authUser.orders_count
            );
            value +=
              (authUser.orders_count / condition.value) *
              (100 / numberOfConditions);
          }
        } else if (condition.type === "orders") {
          if (authUser.orders_count === condition.value) {
            value += 100 / numberOfConditions;
          } else {
            if (authUser.orders_count > condition.value) {
              conditionsLeft.expired = true;
            } else {
              conditionsLeft.orders = preciseNumber(
                condition.value - authUser.orders_count
              );
              value +=
                (authUser.orders_count / condition.value) *
                (100 / numberOfConditions);
            }
          }
        } else if (condition.type === "orders_less") {
          if (authUser.orders_count < condition.value) {
            value += 100 / numberOfConditions;
          } else {
            conditionsLeft.expired = true;
          }
        } else if (
          condition.type === "first_time" &&
          authUser?.orders_count > 0
        ) {
          conditionsLeft.expired = true;
        }
      }
    }
  });

  return { progressValue: parseInt(value), conditionsLeft };
}

function getConditionsLeftAsText(conditionsLeft, props, compact = false) {
  const { language, settings } = props;

  const conditionsText = [];
  const currency = getCurrencyIso(settings,language)

  if (conditionsLeft["userError"]) {
    if (language === "english") conditionsText.push(`Sign in`);
    else conditionsText.push(`تسجيل الدخول`);
  }
  if (conditionsLeft["points"]) {
    if (language === "english") conditionsText.push(`Spend Points`);
    else conditionsText.push(`استخدم تقاط`);
  }

  if (conditionsLeft["value"] > 0)
    if (language === "english")
      conditionsText.push(
        `Purchase ${conditionsLeft["value"]} ${currency} more`
      );
    else
      conditionsText.push(
        `اشتر  ${conditionsLeft["value"]}  ${currency} إضافية`
      );
  if (conditionsLeft["number"] > 0) {
    if (language === "english")
      conditionsText.push(`Purchase ${conditionsLeft["number"]} more items`);
    else conditionsText.push(`اشتر  ${conditionsLeft["number"]} منتج `);
  }

  if (conditionsLeft["products"].length) {
    conditionsLeft["products"].forEach((product) => {
      if (language === "english")
        conditionsText.push(
          `Purchase ${product.quantity} of ${product.name
            .split(",")
            .slice(0, compact ? 2 : undefined)}`
        );
      else
        conditionsText.push(
          `اشتر ${product.quantity} من ${product.ar_name
            .split(",")
            .slice(0, compact ? 2 : undefined)} `
        );
    });
  }
  if (conditionsLeft["coupon"]) {
    if (language === "english") conditionsText.push(`Apply Coupon`);
    else conditionsText.push(`تفعيل الكوبون`);
  }

  if (conditionsLeft["category_number"].length) {
    conditionsLeft["category_number"]
      .slice(0, compact ? 1 : undefined)
      .forEach((category) => {
        if (language === "english")
          conditionsText.push(
            `Purchase ${category.valueLeft} more items from ${category.names
              .slice(0, compact ? 2 : undefined)
              .map((name) => name.name)}`
          );
        else
          conditionsText.push(
            `اشتر   ${category.valueLeft} منتج إضافي من   ${category.names
              .slice(0, compact ? 2 : undefined)
              .map((name) => name.ar_name)} `
          );
      });
  }

  if (conditionsLeft["category_value"].length) {
    conditionsLeft["category_value"]
      .slice(0, compact ? 1 : undefined)
      .forEach((category) => {
        if (language === "english")
          conditionsText.push(
            `Purchase ${
              category.valueLeft
            } more ${currency} from  ${category.names
              .slice(0, compact ? 2 : undefined)
              .map((name) => name.name)}`
          );
        else
          conditionsText.push(
            `اشتر   ${
              category.valueLeft
            } ${currency} إضافية من  ${category.names
              .slice(0, compact ? 2 : undefined)
              .map((name) => name.ar_name)} `
          );
      });
  }
  if (conditionsLeft["service_type"]) {
    const serviceTypesTranslation = {
      delivery: "التوصيل",
      pickup: "الإستلام",
    };
    if (language === "english")
      conditionsText.push(`Use ${conditionsLeft["service_type"]}`);
    else
      conditionsText.push(
        `إستخدام ${serviceTypesTranslation[conditionsLeft["service_type"]]}`
      );
  }
  if (conditionsLeft["delivery_arrival_time"]) {
    const serviceTypesTranslation = {
      asap: "في اقرب وقت",
      scheduled: "توصيل لاحقا",
    };
    if (language === "english")
      conditionsText.push(`Use ${conditionsLeft["delivery_arrival_time"]}`);
    else
      conditionsText.push(
        `إستخدام ${
          serviceTypesTranslation[conditionsLeft["delivery_arrival_time"]]
        }`
      );
  }

  if (conditionsLeft["delivery_area"]) {
    if (language === "english")
      conditionsText.push(
        `Order to any of these areas: ${conditionsLeft["delivery_area"]
          .slice(0, compact ? 2 : undefined)
          .map((area) => area.name)}`
      );
    else
      conditionsText.push(
        `إطلب الى احد المناطق التالية:  ${conditionsLeft["delivery_area"]
          .slice(0, compact ? 2 : undefined)
          .map((area) => area.ar_name)}`
      );
  }

  if (conditionsLeft["branch"]) {
    if (language === "english")
      conditionsText.push(
        `Order from any of these branches:  ${conditionsLeft["branch"]
          .slice(0, compact ? 2 : undefined)
          .map((branch) => branch.name)}`
      );
    else {
      conditionsText.push(
        ` إطلب من احد الفروع التالية:  ${conditionsLeft["branch"]
          .slice(0, compact ? 2 : undefined)
          .map((branch) => branch.ar_name)}`
      );
    }
  }
  if (conditionsLeft["country"]) {
    if (language === "english")
      conditionsText.push(
        `Order from any of these countries:  ${conditionsLeft["country"]
          .slice(0, compact ? 2 : undefined)
          .map((country) => country.name)}`
      );
    else {
      conditionsText.push(
        ` إطلب من احد الدول التالية:  ${conditionsLeft["country"]
          .slice(0, compact ? 2 : undefined)
          .map((country) => country.ar_name)}`
      );
    }
  }

  if (conditionsLeft["orders_more"]) {
    if (language === "english")
      conditionsText.push(`Place ${conditionsLeft["orders_more"]} more orders`);
    else
      conditionsText.push(`تضع ${conditionsLeft["orders_more"]} طلبات إضافية`);
  }
  if (conditionsLeft["orders"]) {
    if (language === "english")
      conditionsText.push(`Place ${conditionsLeft["orders"]} more orders`);
    else conditionsText.push(`تضع ${conditionsLeft["orders"]} طلبات إضافية`);
  }

  if (conditionsLeft["card_scheme"]) {
    if (language === "english")
      conditionsText.push(`Pay using ${conditionsLeft["card_scheme"]}`);
    else conditionsText.push(`ادفع باستخدام ${conditionsLeft["card_scheme"]}`);
  }

  if (conditionsLeft["card_bank"]) {
    if (language === "english")
      conditionsText.push(
        `Pay using a card from  ${conditionsLeft["card_bank"]}`
      );
    else
      conditionsText.push(
        `ادفع باستخدام بطاقة من ${conditionsLeft["card_bank"]}`
      );
  }

  return conditionsText;
}
export {
  getNewPrice,
  getOrderDiscount,
  getProductDiscountAmount,
  getDiscountedPrice,
  getDiscountedPercentage,
  isApplicableCategeoryPromo,
  getSmartPromoProgress,
  getConditionsLeftAsText,
};
